import { createSlice } from "@reduxjs/toolkit";
import { LOGOUT } from "../constants/action-types";

const initialModalState = {
  showDivisionGroupModal: false,
};

const uiModalSlice = createSlice({
  name: "uiModal",
  initialState: initialModalState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("SHOW_DIVISION_GROUP_MODAL", (state) => {
        state.showDivisionGroupModal = true;
      })
      .addCase("HIDE_DIVISION_GROUP_MODAL", (state) => {
        state.showDivisionGroupModal = false;
      })
      .addCase(LOGOUT, () => initialModalState);
  },
});

export const uiModalReducer = uiModalSlice.reducer;
